<template>
  <div>
    <div class="left">
      <ul>
        <li v-for="(device, index) in VideoList" :key="index">
          <div @click="setDeviceToBind(device)">{{device.deviceName}}</div>
        </li>
      </ul>
    </div>
    <div class="center" :class="`videos-${videos.length}`">
      <video-mini
        ref="child"
        class="video-preview"
        :class="{ 'is-binding': deviceToBind }"
        v-for="(video, index) in videos"
        :key="index"
        :activated="activatedVideo === video"
        :video="video"
        :rnd="video.rnd"
        @click.native="deviceToBind ? bindDevices(video,video.index) : activeVideo(video)">
      </video-mini>
    </div>
    <div class="right">
      <div class="count-control">
        <div class="count-control-1" @click="createVideos(1)">
          <div></div>
        </div>
        <div class="count-control-4" @click="createVideos(4)">
          <div v-for="i in [1,2,3,4]" :key="i"></div>
        </div>
        <div class="count-control-9" @click="createVideos(9)">
          <div v-for="i in [1,2,3,4,5,6,7,8,9]" :key="i"></div>
        </div>
      </div>
      <video-mini-control :accessToken="ys7getDev.accessToken" :video="activatedVideo"></video-mini-control>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ys7key:{
        AppKey: 'ec07230a950d4df1a7f9b9c950e331f4',
        Secret:'1a54b970432af2370536fb20c990021f'
      },
      ys7getDev:{
        accessToken: 'at.1v0tpa250woddo3f079242ou2vg9joef-5j2jvc19lc-01atu1e-ayzuaoutv',//accessToken
        pageStart:0,//摄像头起始页  
        pageSize:50//每页数量
      },
      VideoList: [],
      videos: [],
      deviceToBind: null,
      activatedVideo: null,
      controlSpeed: 50
    }
  },
  methods: {
    createVideos (count) {
      if ([1, 4, 9].indexOf(count) < 0) {
        return
      }
      if (this.activatedVideo && count <= this.activatedVideo.index) {
        this.activatedVideo = null
      }
      if (count > this.videos.length) {
        for (let i = this.videos.length; i < count; i++) {
          this.videos.push({
            index: i,
            deviceId: 0,//设备序列号
            deviceName: '',
            channelNo:'',//通道号
            url: '',
            rnd: Math.random()
          })
        }
      } else if (count < this.videos.length) {
        const videos = []
        for (let i = 0; i < count; i++) {
          videos.push(this.videos[i])
        }
        this.videos = videos
      }
      // console.log('createVideos:this.videos',this.videos)
    },
    setDeviceToBind (device) {
      if (this.deviceToBind === device) {
        this.deviceToBind = null
      } else {
        this.deviceToBind = device
      }
    },
    bindDevices (video,index) {
      video.rnd = Math.random()
      video.deviceId = this.deviceToBind.deviceSerial//设备序列号
      video.deviceName = this.deviceToBind.deviceName
      video.channelNo = this.deviceToBind.channelNo//通道号
      video.url = this.deviceToBind.rtmpHd
      // console.log('activatedVideo',this.activatedVideo)
      this.deviceToBind = null
      this.$refs.child[index].initVideo(index);
    },
    activeVideo (video) {
      // console.log('activeVideo',video)
      if (this.activatedVideo === video) {
        this.activatedVideo = null
      } else {
        this.activatedVideo = video
      }
    },
    videoUnload (index) {
      if (index !== null) {
        this.$set(this.videos, index, {
          index,
          deviceId: 0,//设备序列号
          deviceName: '',
          channelNo:'',//通道号
          url: '',
          rnd: Math.random()
        })
        this.activatedVideo = this.videos[index]
      }
    },
    videoDev(){
      let ys7AccessToken=this.$lgetItem('ys7AccessToken')
      if(ys7AccessToken){
        this.ys7getDev.accessToken=ys7AccessToken
      }
      this.$postUrlNoToken('https://open.ys7.com/api/lapp/live/video/list', this.ys7getDev).then(resp => {
        if(resp.data.code==='10002'||resp.data.code===10002){
          this.getAccessToken()
        }else{
          this.VideoList = resp.data.data
          this.activatedVideo = resp.data.data[0]
          this.activatedVideo.index =0
          this.activatedVideo.deviceId = this.activatedVideo.deviceSerial//设备序列号
        }
      })  
    },
    getAccessToken(){
      this.$postUrlNoToken('https://open.ys7.com/api/lapp/token/get', {appKey:this.ys7key.AppKey,appSecret:this.ys7key.Secret}).then(resp => {
        if(resp.data.code==='200'||resp.data.code===200){
          let newAccessToken=resp.data.data.accessToken
          this.ys7getDev.accessToken=newAccessToken
          this.$lrmItem('ys7AccessToken')
          this.$lsetItem(newAccessToken, 'ys7AccessToken')
          this.videoDev()
        }
      })
    }
  },
  mounted () {
    this.videoDev()
    this.createVideos(4)
    this.eventBus.$on('videoUnload', this.videoUnload)
  },
  beforeDestroy () {
    this.eventBus.$off('videoUnload', this.videoUnload)
  }
}
</script>

<style scoped>
.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
}
.num {
  height: 100%;
  width: 100%;
}
.left {
  position: fixed;
  top: 60px;
  left: 0px;
  bottom: 0px;
  width: 180px;
  background: #333;
  color:#fff;
}
.left .el-select {
  display: block;
  margin: 15px 0;
  padding: 0 15px;
  box-sizing: border-box;
}
.left .el-select + svg {
  display: none;
}
.left ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.left ul div {
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  box-sizing: border-box;
}
.left > ul ul li {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.left > ul ul li:hover {
  background: rgba(255, 255, 255, 0.1);
}
.left > ul {
  font-size: 16px;
  margin: 15px 0;
}
.center {
  position: fixed;
  top: 60px;
  left: 180px;
  right: 180px;
  bottom: 0;
}
.right {
  position: fixed;
  top: 60px;
  bottom: 0px;
  right: 0px;
  width: 180px;
  background: #333;
  color: #fff;
}

.video-preview-control-main {
    position: relative;
    padding-top: 100%;
    margin-top: 10px;
}
.circle {
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border-radius: 50%;
    border: 40px solid #3f475a;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    background: #1b1b1b;
}
.arrow {
    position: absolute;
    cursor: pointer;
    user-select: none;
}
.arrow:before {
    content: '';
    display: inline-block;
    position: absolute;
    border: 10px solid #ccdaeb;
    z-index: 1;
}
.arrow:hover:before {
    border: 10px solid #fff;
}
.arrow:active:before {
    border: 10px solid #666;
}
.arrow:after {
    content: '';
    display: inline-block;
    position: absolute;
    border: 10px solid transparent;
    z-index: 0;
}
.arrow-up {
    top: -40px;
    left: 0;
    width: 70px;
    height: 40px;
}
.arrow-up:before {
    top: 5px;
    left: 25px;
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
}
.arrow-up:after {
    top: 7px;
    left: 27px;
    border-bottom-color: rgba(0, 0, 0, 0.3);
}
.arrow-left {
    top: 0;
    left: -40px;
    width: 40px;
    height: 70px;
}
.arrow-left:before {
    top: 25px;
    left: 5px;
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-bottom-color: transparent !important;
}
.arrow-left:after {
    top: 27px;
    left: 7px;
    border-right-color: rgba(0, 0, 0, 0.3);
}
.arrow-right {
    top: 0;
    left: 70px;
    width: 40px;
    height: 70px;
}
.arrow-right:before {
    top: 25px;
    left: 15px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
}
.arrow-right:after {
    top: 27px;
    left: 17px;
    border-left-color: rgba(0, 0, 0, 0.3);
}
.arrow-down {
    top: 70px;
    left: 0;
    width: 72px;
    height: 40px;
}
.arrow-down:before {
    top: 15px;
    left: 25px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
}
.arrow-down:after {
    top: 17px;
    left: 27px;
    border-top-color: rgba(0, 0, 0, 0.3);
}
.camera {
    position: absolute;
    background: #cfdff1;
    color: #1b1b1b;
    width: 48px;
    height: 24px;
    line-height: 20px;
    text-align: center;
    left: 11px;
    box-sizing: border-box;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
}
.camera-up {
    top: 11px;
    border-top-left-radius: 48px;
    border-top-right-radius: 48px;
    border-bottom: 1px solid #1b1b1b;
}
.camera-down {
    bottom: 11px;
    border-bottom-left-radius: 48px;
    border-bottom-right-radius: 48px;
    border-top: 1px solid #1b1b1b;
}
.slider {
    overflow: hidden;
}
.slider > * {
    float: left;
}
.slider > span {
    display: inline-block;
    width: 30px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    vertical-align: top;
}
.slider .speed {
    width: 120px;
}
.right .count-control {
  border-bottom: 1px solid #696969;
  overflow: hidden;
  text-align: center;
  height: 80px;
}
.right .count-control > div {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin: 20px 5px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #696969;
  background: #23252a;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.right .count-control > div > div {
  float: left;
  border: 1px solid #696969;
  margin: -1px;
}
.right .count-control-1 > div {
  width: 36px;
  height: 36px;
}
.right .count-control-4 > div {
  width: 18px;
  height: 18px;
}
.right .count-control-9 > div {
  width: 12px;
  height: 12px;
}
.videos-1 .video-container {
  width: 100%;
  height: 100%;
}
.videos-4 .video-container {
  width: 50%;
  height: 50%;
}
.videos-9 .video-container {
  width: 33.333333%;
  height: 33.333333%;
}
.video-preview.is-binding {
  cursor: pointer;
}
.video-preview.is-binding:before {
  content: '在这里显示';
  display: block;
  position: absolute;
  font-size: 24px;
  color: #fff;
  background: #000;
  width: 100%;
  height: 100%;
  text-align: center;
  box-sizing: border-box;
  padding-top: 2em;
  opacity: 0.5;
  z-index: 2;
}
.video-preview.is-binding:hover:before {
  opacity: 0.7;
}
.right .count-control {
  border-bottom: 1px solid #696969;
  overflow: hidden;
  text-align: center;
  height: 80px;
}
.right .count-control > div {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin: 20px 5px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #696969;
  background: #23252a;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.right .count-control > div > div {
  float: left;
  border: 1px solid #696969;
  margin: -1px;
}
.right .count-control-1 > div {
  width: 36px;
  height: 36px;
}
.right .count-control-4 > div {
  width: 18px;
  height: 18px;
}
.right .count-control-9 > div {
  width: 12px;
  height: 12px;
}
.autocomplete-wrapper {
  position: relative;
}
.autocomplete-wrapper .el-input input {
  border-radius: 18px;
  padding-right: 35px;
}
.autocomplete-search {
  position: absolute;
  top: 10px;
  right: 30px;
  color: #333;
}
</style>